// libraries
import { atom, atomFamily, selector } from 'recoil';

/** 비콘 전체 리스트 */
export const BeaconAtomFamily = atomFamily({
  key: 'BeaconAtomFamily',
  default: []
});

/** 비콘 추가 모드 */
export const BeaconCreateModeAtom = atom({
  key: 'BeaconCreateModeAtom',
  default: false
});

/** 선택된 비콘 */
export const SelectedBeaconAtom = atom({
  key: 'SelectedBeaconAtom',
  default: null
});

/** 비콘 리스트를 위한 selector */
export const BeaconListSelector = selector({
  key: 'BeaconListSelector',
  get: ({ get }) => {
    return get(BeaconAtomFamily('all'));
  }
});

/** 카메라 이동 비콘 */
export const CameraMoveBeaconAtom = atom({
  key: 'CameraMoveBeaconAtom',
  default: null
});
